export const createCampaignTr = {
  title: 'Kampanya Oluştur',
  subtitle: '5 basit adımda yeni bir reklam kampanyası başlatın.',
  autoSaved: 'Otomatik kaydedildi',
  back: 'Geri',
  continue: 'Devam Et',
  launchCampaign: 'Kampanyayı Başlat',
  stepOf: 'Adım {{current}} / {{total}}',
  tips: {
    proTip: 'Profesyonel İpucu',
    proTipText: 'Müşteri Adayı Oluşturma reklamları günlük ₺500+ bütçe ile en iyi performansı gösterir',
    guaranteedResults: 'Garantili Sonuçlar',
    guaranteedResultsText: 'Şablonlarımız eğitim kampanyaları için test edilmiş ve optimize edilmiştir',
    supportAvailable: 'Destek Mevcut',
    supportAvailableText: 'Ekibimiz her kampanyayı yayına girmeden önce inceler'
  }
};

export default createCampaignTr;
